import axios from "axios";

const top = {
  namespaced: true,
  state() {
    return {
      notifications: [],
    }
  },
  getters: {
    getParameter() {
      return {
        sort_attribute: 'publication_from',
        sort_direction: 'desc',
      };
    },
  },
  mutations: {
    setData(state, data) {
      state.notifications = data;
    },
  },
  actions: {
    load({commit, getters}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/notifications', {params: getters.getParameter}).then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        }).catch(() => reject());
      });
    }
  }
}

export default top
